let mapApiLoaded = false;
let callbacks = [];

export function loadGoogleMapsApi(apiKey, libraries = []) {
  return new Promise((resolve, reject) => {
    // 如果API已經加載，直接返回
    if (mapApiLoaded) {
      resolve(window.google);
      return;
    }
    
    // 如果加載正在進行，將回調加入隊列
    if (callbacks.length > 0) {
      callbacks.push({ resolve, reject });
      return;
    }
    
    callbacks.push({ resolve, reject });
    
    // 創建腳本標簽
    const script = document.createElement('script');
    const librariesParam = libraries.length > 0 ? `&libraries=${libraries.join(',')}` : '';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}${librariesParam}&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      reject(new Error('Failed to load Google Maps API'));
      callbacks = [];
    };
    
    // 全局回調函數
    window.initGoogleMaps = () => {
      mapApiLoaded = true;
      const google = window.google;
      callbacks.forEach(({ resolve }) => resolve(google));
      callbacks = [];
    };
    
    document.head.appendChild(script);
  });
}